
import { defineComponent, getCurrentInstance, ref } from 'vue'
import { EpbTextbox } from '../epb-textbox'

export default defineComponent({
  name: 'EpbColorPicker',
  components: {
    EpbTextbox,
  },
  props: {
    label: {
      type: String,
      default: undefined,
    },
    value: {
      type: String,
      default: '#000000',
    },
    error: {
      type: String,
      default: '',
    },
    help: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const ctx = getCurrentInstance()

    const baseClass = 'epb-color-picker'

    const selectedColor = ref<string>(props.value)

    const colorError = ref<boolean>(false)

    function onColorInputChange(event: Event): void {
      const target = event.target as HTMLInputElement
      selectedColor.value = target.value
      colorError.value = false

      ctx.proxy.$emit('input', selectedColor.value)
    }

    function onTextInputChange(value: string): void {
      const hexRegExp = /^#([A-F0-9]{6})$/
      const newColor = `#${value.toUpperCase().replaceAll('#', '')}`

      colorError.value = !hexRegExp.test(newColor)

      selectedColor.value = newColor
      ctx.proxy.$emit('input', selectedColor.value)
    }

    return {
      baseClass,
      selectedColor,
      colorError,
      onColorInputChange,
      onTextInputChange,
    }
  },
})
